export default __webpack_public_path__ + "img/mantenimiento.de0cccb6.svg";